export const grid = 8;
export const borderRadius = 2;
